import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Calendar, Clock } from 'lucide-react';
import { Reveal, WordReveal } from '../components/Motion';
import { journalArticles } from '../mock/journal';

export default function Blog() {
  const [hero, ...rest] = journalArticles;
  return (
    <div className="relative">
      <section className="px-6 md:px-12 lg:px-20 pt-32 pb-16 relative overflow-hidden">
        <div className="blob" style={{ width: 500, height: 500, background: 'var(--accent)', top: '-20%', left: '-10%', opacity: 0.12 }}/>
        <div className="max-w-[1500px] mx-auto relative">
          <span className="section-eyebrow">Journal</span>
          <h1 className="h-display mt-8 text-[12vw] md:text-[8.5vw]"><WordReveal text="Field notes."/></h1>
          <p className="mt-8 max-w-2xl text-muted text-[15px] leading-relaxed">Essays, experiments, and the occasional rant. Mostly about design, sometimes about AI, always written by a human.</p>
        </div>
      </section>

      <section className="px-6 md:px-12 lg:px-20 pb-32">
        <div className="max-w-[1500px] mx-auto">
          <Reveal>
            <Link to={`/blog/${hero.slug}`} className="group grid md:grid-cols-12 gap-8 items-center pb-16 border-b" style={{ borderColor: 'var(--line)' }} data-cursor="hover">
              <div className="md:col-span-7 aspect-[16/10] overflow-hidden rounded-2xl ring-glow">
                <img src={hero.cover} alt={hero.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-[1400ms]"/>
              </div>
              <div className="md:col-span-5">
                <div className="flex items-center gap-3 text-[11px] uppercase tracking-widest"><span className="text-accent">{hero.cat}</span><span className="text-dim">&bull;</span><span className="text-dim">{hero.date}</span></div>
                <h2 className="h-display text-4xl md:text-5xl mt-6">{hero.title}</h2>
                <p className="text-muted mt-5 leading-relaxed">{hero.excerpt}</p>
                <span className="link-arrow mt-8">Read the entry <span className="arrow"><ArrowUpRight size={14}/></span></span>
              </div>
            </Link>
          </Reveal>

          <div className="mt-20 grid md:grid-cols-3 gap-6">
            {rest.map((p, i) => (
              <Reveal key={p.id} delay={i * 0.05}>
                <Link to={`/blog/${p.slug}`} className="card-prem overflow-hidden group h-full block" data-cursor="hover">
                  <div className="aspect-[16/10] overflow-hidden">
                    <img src={p.cover} alt={p.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-[1200ms]"/>
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-4 text-[11px] text-dim uppercase tracking-widest">
                      <span className="inline-flex items-center gap-1.5"><Calendar size={11}/>{p.date}</span>
                      <span className="inline-flex items-center gap-1.5"><Clock size={11}/>{p.read}</span>
                    </div>
                    <h3 className="font-display text-xl mt-4">{p.title}</h3>
                    <p className="text-muted text-[13px] mt-3 leading-relaxed">{p.excerpt}</p>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
